window.themeLog = window.themeLog || function () {};
/* ============================================
   BREADCRUMBS - Collection Context Memory
   Onthoudt van welke collection de gebruiker kwam
   ============================================ */

(function() {
  'use strict';

  // Storage key voor collection context
  const STORAGE_KEY = 'lastVisitedCollection';

  // Op collection pages: sla collection op wanneer product link geklikt wordt
  if (window.location.pathname.includes('/collections/')) {
    const collectionMatch = window.location.pathname.match(/\/collections\/([^\/]+)/);
    if (collectionMatch) {
      const collectionHandle = collectionMatch[1];

      // Luister naar product link clicks
      document.addEventListener('click', function(e) {
        const productLink = e.target.closest('a[href*="/products/"]');
        if (productLink) {
          const productUrl = productLink.getAttribute('href');
          const productHandle = productUrl.match(/\/products\/([^\/\?#]+)/)?.[1];

          if (productHandle) {
            // Sla collection context op
            try {
              localStorage.setItem(STORAGE_KEY, JSON.stringify({
                collectionHandle: collectionHandle,
                productHandle: productHandle,
                timestamp: Date.now()
              }));
              themeLog('💾 Saved collection context:', collectionHandle, 'for product:', productHandle);
            } catch (e) {
              console.error('Failed to save collection context:', e);
            }
          }
        }
      });
    }
  }

  // Op product pages: herstel collection uit localStorage
  if (window.location.pathname.includes('/products/')) {
    const currentProductHandle = window.location.pathname.match(/\/products\/([^\/\?#]+)/)?.[1];

    if (currentProductHandle) {
      try {
        const savedContext = localStorage.getItem(STORAGE_KEY);
        if (savedContext) {
          const context = JSON.parse(savedContext);

          // Check of dit dezelfde product is (max 1 uur oud)
          const isRecent = (Date.now() - context.timestamp) < 3600000; // 1 uur
          const isSameProduct = context.productHandle === currentProductHandle;

          if (isRecent && isSameProduct) {
            themeLog('✅ Restoring collection context:', context.collectionHandle);

            // Haal product collections data op
            const collectionsData = document.getElementById('product-collections-data');
            if (collectionsData) {
              const data = JSON.parse(collectionsData.textContent);
              const savedCollection = data.collections.find(c => c.handle === context.collectionHandle);

              if (savedCollection) {
                // Update breadcrumb met opgeslagen collection
                const breadcrumbCollectionItem = document.querySelector('[data-breadcrumb-collection]');
                if (breadcrumbCollectionItem) {
                  const link = breadcrumbCollectionItem.querySelector('a');
                  const span = breadcrumbCollectionItem.querySelector('span[itemprop="name"]');

                  if (link && span) {
                    link.href = savedCollection.url;
                    span.textContent = savedCollection.title;
                    themeLog('🔄 Updated breadcrumb to:', savedCollection.title);
                  }
                } else {
                  // Geen breadcrumb item gevonden - maak een nieuwe aan
                  const breadcrumbList = document.querySelector('.breadcrumb-list');
                  const homeItem = breadcrumbList?.querySelector('li:first-child');

                  if (breadcrumbList && homeItem) {
                    // Maak nieuwe collection breadcrumb item
                    const collectionItem = document.createElement('li');
                    collectionItem.className = 'breadcrumb-item';
                    collectionItem.setAttribute('itemprop', 'itemListElement');
                    collectionItem.setAttribute('itemscope', '');
                    collectionItem.setAttribute('itemtype', 'https://schema.org/ListItem');
                    collectionItem.setAttribute('data-breadcrumb-collection', '');
                    collectionItem.innerHTML = `
                      <a href="${savedCollection.url}" itemprop="item">
                        <span itemprop="name">${savedCollection.title}</span>
                      </a>
                      <meta itemprop="position" content="2">
                    `;

                    // Update product item position
                    const productItem = breadcrumbList.querySelector('li:last-child');
                    if (productItem) {
                      const positionMeta = productItem.querySelector('meta[itemprop="position"]');
                      if (positionMeta) {
                        positionMeta.setAttribute('content', '3');
                      }
                    }

                    // Insert na home item
                    homeItem.after(collectionItem);
                    themeLog('✅ Added collection breadcrumb:', savedCollection.title);
                  }
                }
              }
            }
          } else {
            themeLog('⚠️ Collection context expired or different product');
            localStorage.removeItem(STORAGE_KEY);
          }
        }
      } catch (e) {
        console.error('Failed to restore collection context:', e);
      }
    }
  }

  // Op homepage product sections: sla eerste collection op
  if (window.location.pathname === '/' || window.location.pathname === '') {
    document.addEventListener('click', function(e) {
      const productLink = e.target.closest('a[href*="/products/"]');
      if (productLink) {
        const productUrl = productLink.getAttribute('href');
        const productHandle = productUrl.match(/\/products\/([^\/\?#]+)/)?.[1];

        if (productHandle) {
          // Check of er een data-collection attribuut is (indien beschikbaar)
          const productCard = productLink.closest('[data-product-collections]');
          let collectionHandle = null;

          if (productCard) {
            try {
              const collections = JSON.parse(productCard.getAttribute('data-product-collections'));
              collectionHandle = collections[0]; // Eerste collection
            } catch (e) {
              console.error('Failed to parse product collections:', e);
            }
          }

          if (collectionHandle) {
            // Sla collection context op
            try {
              localStorage.setItem(STORAGE_KEY, JSON.stringify({
                collectionHandle: collectionHandle,
                productHandle: productHandle,
                timestamp: Date.now()
              }));
              themeLog('💾 Saved collection context from homepage:', collectionHandle);
            } catch (e) {
              console.error('Failed to save collection context:', e);
            }
          }
        }
      }
    });
  }
})();
